// extracted by mini-css-extract-plugin
export default {"paginator":"JobZoneList_paginator__QY9TV","tableActions":"JobZoneList_tableActions__uJmzQ"};